import { chakra } from '@chakra-ui/react'

export const Button = chakra('button', {
    baseStyle: ({ theme }) => ({
        position: 'relative',
        boxSizing: 'border-box',
        cursor: 'pointer',
        color: theme.palette.toolbar.btnColor,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        _hover: {
            color: theme.palette.toolbar.btnHoverColor,
        },
    }),
})

export const ChildrenWrapper = chakra('span', {
    baseStyle: {
        padding: '0 12px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
    },
})
